<template>
  <div>

    <form id="search-form">
      <input placeholder="Voice Search" focus outlined class="form-control-6 input is-success"/>
      <!-- <i id="search" ref="search" class="search button"><i class="fas fa-microphone"></i></i> -->
   </form>
   <p class="info"></p>
  </div>

 </template>

<script>

export default {
  data() {
    return {
      // Placholder text on init search

    }
  },
  methods: {

  },
  mounted() {
  
  },
};
</script>
<style scoped>
  .form-control-6 {
    border: 1px solid #78b59c;
    padding: 4px 4px;
    margin-block: 1px 3px;
    margin-top: 0.8rem;
    margin-left: 570px;
  }
  @media only screen and (max-width: 600px) {
  .form-control-6 {
    border: 1px solid #78b59c;
    padding: 20px 20px;
    margin-block: 3px 5px;
    margin-left: 0px;
    border-radius: 10px;
    font-size: 12px;
    background: transparent;
    color: rgb(36, 212, 65);
  }
  }
  .container {
    padding: 30px 50px;
  }
  #search-form {
    width: 100%;
  }
  #search-form input {
    padding: 20px 20px 20px 20px;
    border: 1px solid rgba(36, 212, 65, 0);
    width: 74.7%;
    height: 100px;
    margin-top: 30px;
    margin-right: 0px;
    margin-bottom: 20px;
    margin-left: 218px;
    border-radius: 5px;
    font-size: 12px;
    background: transparent;
    color: rgb(36, 212, 65);
    text-transform: capitalize;
    top: -20px;
    right: 0px;
    bottom: auto;
    left: 0px;
    z-index: 1000;
  }
  .button {
    border: 1px solid #78b59c;
    border-radius: 5px;
    padding: 10px;
    width: 25px;
    background: transparent;
    color: rgb(36, 212, 65);
  }
  .info {
    top: 10px;
    margin-left: 11rem;
    width: 300px;
    text-align: center;
    font-size: 1.1rem;
    position: absolute;
    padding-left: 5px;
    padding-right: 5px;
    font-style: normal;
    color: rgb(51, 207, 77);
    border-radius: 5px;
  }
  @media (max-width: 1200px) {
    #search-form { width: 50%; }
  }
  @media (max-width: 768px) {
    .container { padding: 30px 35px; }
    #search-form { width: 100%; }
    .info { font-size: 0.5rem; }
  }
  </style>
